import { RowExportTypePdf } from "types";
import { PdfTemplate } from "components";
import { ListDocumenType } from "../types";

export function PdfDocumentType(props: { dataList: ListDocumenType[] }) {
  const columns = [
    { header: "NO", key: "no", width: 5 },
    { header: "CODE", key: "code", width: 10 },
    { header: "GROUP ASSET", key: "document_type", width: 10 },
    { header: "DESCRIPTION", key: "description", width: 15 },
  ];

  const dataMap: RowExportTypePdf[] = props.dataList.map((item, index) => ({
    no: index + 1,
    code: item.mr_document_code ?? "-",
    document_type: item.mr_document_name ?? "-",
    description: item.description ?? "-",
  }));

  return <PdfTemplate data={dataMap} column={columns} title="Document Type" />;
}
